import { Superficie_anteproyecto } from './../../../models/superficie_anteproyecto.model';
import { Component, ViewChild,  TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-superficie_anteproyecto",
    templateUrl: "./superficie_anteproyecto.component.html",
    styleUrls: ["./superficie_anteproyecto.component.css"],
    providers: [FormService]
})
export class Superficie_anteproyectoComponent {
    @ViewChild('openModal') openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public superficie_anteproyecto: Superficie_anteproyecto;
      public form;
      
 
     public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog){

        this.form = new FormGroup({
            util1: new FormControl(''),
            comun1:new FormControl(''),
            total1 :new FormControl(''),
            util2: new FormControl(''),
            comun2:new FormControl(''),
            total2 :new FormControl(''),
            util3: new FormControl(''),
            comun3:new FormControl(''),
            total3 :new FormControl(''),
            totalt :new FormControl('')
        })

        if(!JSON.parse(localStorage.getItem("superficie_anteproyecto"))){
            localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("superficie_anteproyecto"));
            this.form.controls['util1'].setValue(this.rows[0]?this.rows[0].util1:'')
            this.form.controls['comun1'].setValue(this.rows[0]?this.rows[0].comun1:'')
            this.form.controls['total1'].setValue(this.rows[0]?this.rows[0].total1:'')
            this.form.controls['util2'].setValue(this.rows[0]?this.rows[0].util2:'')
            this.form.controls['comun2'].setValue(this.rows[0]?this.rows[0].comun2:'')
            this.form.controls['total2'].setValue(this.rows[0]?this.rows[0].total2:'')
            this.form.controls['util3'].setValue(this.rows[0]?this.rows[0].util3:'')
            this.form.controls['comun3'].setValue(this.rows[0]?this.rows[0].comun3:'')
            this.form.controls['total3'].setValue(this.rows[0]?this.rows[0].total3:'')
            this.form.controls['totalt'].setValue(this.rows[0]?this.rows[0].totalt:'')
        }
      
        this.superficie_anteproyecto = {util1:'',comun1:'',total1:'',util2:'',comun2:'',total2:'',util3:'',comun3:'',total3:'',totalt:''};
       

    }
 
    add_superficie_anteproyecto(){
        localStorage.setItem("superficie_anteproyecto",JSON.stringify([]));
        this.actualRow = localStorage.getItem("superficie_anteproyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            util1: this.form.value.util1,
            comun1: this.form.value.comun1,
            total1: this.form.value.total1,
            util2: this.form.value.util2,
            comun2: this.form.value.comun2,
            total2: this.form.value.total2,
            util3: this.form.value.util3,
            comun3: this.form.value.comun3,
            total3: this.form.value.total3,
            totalt: this.form.value.totalt         
            
        })
        localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
        

    }
    delete_superficie_anteproyecto(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
            }
        }
    }

   

}